import { render, staticRenderFns } from "./independentDomain.vue?vue&type=template&id=270e779c&scoped=true&"
import script from "./independentDomain.vue?vue&type=script&lang=js&"
export * from "./independentDomain.vue?vue&type=script&lang=js&"
import style0 from "./independentDomain.vue?vue&type=style&index=0&id=270e779c&scoped=true&lang=scss&"
import style1 from "./independentDomain.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270e779c",
  null
  
)

export default component.exports